import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { AppBar, Toolbar, IconButton, Typography, Box, Avatar, Menu, MenuItem } from '@mui/material';
import { Menu as MenuIcon, AccountCircle } from '@mui/icons-material';
import { useGlobalContext } from "../GlobalContext";

const companies = [
  { id: 3, name: "Mayaland", location: "Mayaland Atlanta", color: "#1565c0", logo: "https://mayaland-src.s3.us-east-2.amazonaws.com/logo_mayaland.png" },
  { id: 6, name: "Altitude", location: "Altitude Atlanta", color: "#212121", logo: "https://mayaland-src.s3.us-east-2.amazonaws.com/ALT1.png" },
];

const TopMenu = () => {
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const company = companies.find(company => company.id === parseInt(id));
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUser, setSelectedUser] = useState('John Doe');
  const { toggleDrawer } = useGlobalContext();

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="fixed" sx={{ zIndex: 1201 }} style={{ backgroundColor: company.color }}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        {/* Menu de hamburguesa en el lado izquierdo */}
        <IconButton edge="start" color="inherit" onClick={toggleDrawer} sx={{ mr: 2 }}>
          <MenuIcon />
        </IconButton>
        
        {/* Logo de la empresa */}
        <img src={company.logo} alt="Company Logo" style={{ maxHeight: 25 }} />
        
        {/* Espacio vacío para asegurar que los elementos estén en sus lugares */}
        <Box sx={{ flexGrow: 1 }} />

        {/* Avatar con dropdown en el lado derecho */}
        <Avatar
          sx={{
            backgroundColor: '#1976d2',
            cursor: 'pointer',
            width: 40,
            height: 40,
            marginLeft: 2,
          }}
          onClick={handleMenuClick}
        >
          <AccountCircle />
        </Avatar>
        <Typography variant="p" style={{ fontSize: '0.8rem', marginLeft: 4 }}>User</Typography>
        
        {/* Menu dropdown */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={handleMenuClose}>Logout</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  )
}

export default TopMenu;